import React from 'react'

const Debit = React.lazy(() => import('pages/Debit/DebitPage'));


const DebitRoutes = [
    {
        path: '/debit',
        exact: true,
        name: 'Danh sách công nợ',
        function: 'MD_DEBIT_VIEW',
        component: Debit,
    },
]

export default DebitRoutes